import {
    createRequestFilters,
    ICustomFilter,
    ListProviderClaimEligibilitiesOrderEnum,
    ListProviderClaimEligibilitiesRequest,
    ListProviderClaimPaymentsOrderEnum,
    ProviderClaimEligibility,
    ProviderEligibilitySortType,
} from '@enter/core';
import { action, observable, runInAction } from 'mobx';
import { EligibilityGenerator } from './eligibility.generator';
import { EligibilityService } from './eligibility.service';
import { IFeatures } from './root.store';
import { appendTo } from './util';

export interface IEligibilityListing {
    eligibilities: ProviderClaimEligibility[];
    limit?: number;
    offset?: number;
    total?: number;
}

export interface IEligibilityListingRequest {
    page?: number;
    pageSize?: number;
    filters?: ICustomFilter[];
}

export interface IEligibilityDetailRequest {
    eligibilityId: string;
    page?: number;
    pageSize?: number;
    sortColumns?: ProviderEligibilitySortType[];
    sortOrders?: ListProviderClaimPaymentsOrderEnum[];
    filters?: ICustomFilter[];
}

export class EligibilityStore {
    @observable public eligibilities: ProviderClaimEligibility[] = [];

    private features: IFeatures;
    private eligibilityGenerator: EligibilityGenerator;
    private EligibilityService: EligibilityService = new EligibilityService();

    constructor(features: IFeatures, eligibilityGenerator: EligibilityGenerator) {
        this.features = features;
        this.eligibilityGenerator = eligibilityGenerator;
    }

    @action
    public async loadEligibilityListing(clr: IEligibilityListingRequest): Promise<IEligibilityListing> {
        const lpcr = clr2lpcr(clr);
        const listing = await (this.features.isDemo
            ? this.eligibilityGenerator.generateEligibilityListing(lpcr)
            : this.EligibilityService.fetchEligibilityListing(lpcr));
        if (!listing) {
            throw new Error(`No eligibilities available`);
        }
        const { eligibilities } = listing;
        runInAction(() => {
            this.eligibilities = appendTo<ProviderClaimEligibility>(this.eligibilities, eligibilities);
        });
        return listing;
    }
}

// Convert from IEligibilityListingRequest to ListProviderClaimEligibilityRequest
const clr2lpcr = (clr: IEligibilityListingRequest): ListProviderClaimEligibilitiesRequest => {
    const filters = createRequestFilters(clr.filters, true);
    return {
        ...filters,
        limit: clr.pageSize,
        offset: clr.pageSize && clr.page ? (clr.pageSize * clr.page) : 0,
        order: [ListProviderClaimEligibilitiesOrderEnum.DESCENDING],
        sort: [ProviderEligibilitySortType.CREATED],
        filterTypeParameter: ['EQ:MANUAL'],
    };
};
